<ion-header class="header --w-back-button">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="routes.login" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="login --no-bg">
  <div class="login__background"></div>
  <div class="login__content">
    <app-logo class="--big login__content__logo"></app-logo>
    <span class="login__content__title" [innerHTML]="token ? 'Neues Passwort festlegen' : 'Probleme beim einloggen?'"></span>
    <span
      class="login__content__text"
      [innerHTML]="token ? 'Legen Sie Ihr neues Passwort fest, indem Sie es hier eingeben' : 'Wir senden Ihnen dann Anweisungen an Ihr E-Mail-Konto, um Ihr Passwort neu zu setzen.'"
    ></span>

    <form class="login__content__form" [formGroup]="form" (keyup.enter)="(token ? resetPassword() : requestPasswordResetLink())">
      <ion-item class="login__content__form__item">
        <ion-label class="label" position="stacked" [innerHTML]="'E-Mail'"></ion-label>
        <ion-input class="input" formControlName="email" placeholder="Deine E-Mail"></ion-input>
      </ion-item>

      <ng-container *ngIf="token">
        <ion-item class="login__content__form__item">
          <ion-label class="label" position="stacked" [innerHTML]="'Passwort'"></ion-label>
          <ion-input
            class="input"
            [type]="showPassword ? 'text' : 'password'"
            formControlName="password"
            placeholder="Passwort"
          ></ion-input>
          <ion-button class="input-button button --icon" fill="clear" (click)="toggleShowPassword()" tabindex="-1">
            <ion-icon [name]="showPassword ? 'eye-off' : 'eye'"></ion-icon>
          </ion-button>
        </ion-item>
      </ng-container>

      <div class="login__content__form__buttons --forget-password">
        <ion-button
          *ngIf="!token"
          class="button login__content__form__buttons__button"
          [disabled]="form.controls.email.invalid"
          (click)="requestPasswordResetLink()"
        >
          <span *ngIf="(loading$ | async) === false" [innerHTML]="'weiter'"></span>
          <ion-spinner *ngIf="(loading$ | async)"></ion-spinner>
        </ion-button>

        <ion-button *ngIf="token" class="button login__content__form__buttons__button" [disabled]="form.invalid" (click)="resetPassword()">
          <span *ngIf="(loading$ | async) === false" [innerHTML]="'Reset'"></span>
          <ion-spinner *ngIf="(loading$ | async)"></ion-spinner>
        </ion-button>

        <ion-back-button
          icon=""
          text="Zurück zu Login"
          class="button --text --dark login__content__form__buttons__button"
          [routerLink]="[routes.login]"
          [queryParams]="{ email: form.value.email }"
          [innerHTML]="'zurück zum Login'"
        ></ion-back-button>
      </div>
    </form>
  </div>
</ion-content>
